module.exports = __webpack_public_path__ + "img/img1.fe4d6b26.jpg";